<template>
  <b-row>
    <b-col class="pl-5 pr-5" md="12">
      <b-form-group label-cols-md="2" content-cols-md="6" :label="$t('ConsentForm')" label-for="fname">
        <v-select transition="" v-model="consentForm"
                  :reduce="s => s" label="name"
                  :options="consentFormList">
        <template v-slot:no-options> {{$t('NoMatchingOptionsMessage')}} </template> </v-select>
      </b-form-group>
    </b-col>
    <smart-duo filterOptionsUrl="/ConsentForm/CustomerConsentFormVue"
               customRenderFor="CustomerSummary" :customerId="customerId"></smart-duo>

    <DigitalSignatureSendModal ref="digitalSignatureSendModal" @sent="onDigitalSignatureSent" />
    <DigitalSignatureAnswersModal ref="digitalSignatureAnswersModal" />
  </b-row>
</template>
<script>
  import axios from '../../../services/index'
  import SmartDuo from '../Shared/SmartDuo'
  import consentFormService from '../../../services/customerConsentForm'
  import { refreshSmartDuoData } from '../../../helpers/dataRefresher'
  import DigitalSignatureSendModal from '../../../components/digitalSignature/DigitalSignatureSendModal'
  import DigitalSignatureAnswersModal from '../../../components/digitalSignature/DigitalSignatureAnswersModal'

  export default {
    name: 'ConsentForm',
    props: {
      customerId: String
    },
    components: {
      SmartDuo,
      DigitalSignatureSendModal,
      DigitalSignatureAnswersModal
    },
    data() {
      return {
        consentForm: '',
        consentFormList: [],
        customerInfo: null
      }
    },
    methods: {
      getConsentFormList() {
        consentFormService.getConsentFormList().then((result) => {
          this.consentFormList = result;
        })
      },
      getCustomerInfo() {
        axios.get(`/Customer/GetCustomerInfo?id=${this.customerId}`)
          .then(response => {
            this.customerInfo = response.data;
          })
          .catch(() => {
            this.customerInfo = null;
          });
      },
      insertCustomerConsentForm() {

        var url = `/consentForm/InsertCustomerConsentForm?`;

        if (this.consentForm.isCustom) {
          url += `customerId=${this.customerId}&customConsentFormId=${this.consentForm.id}`;
        }
        else {
          url += `customerId=${this.customerId}&reportName=${this.consentForm.reportName}&consentFormName=${this.consentForm.name}`;
        }

        consentFormService.insertCustomerConsentForm(url).then(response => {
          if (response) {
            this.$toastr.success(this.$t("Success"));
            this.consentForm = '';
            refreshSmartDuoData();
          }
          else
            this.$toastr.error(this.$t("Error"));
        });
      },
      openDigitalSignatureFromRow(customerId, customConsentFormId, formName, customerConsentFormId) {
        if (this.$refs.digitalSignatureSendModal) {
          this.$refs.digitalSignatureSendModal.open({
            customerId: customerId,
            customerName: this.customerInfo?.name || '',
            customerPhone: this.customerInfo?.phone || '',
            formName: formName,
            customConsentFormId: customConsentFormId,
            customerConsentFormId: customerConsentFormId,
            branchId: this.$store.state.Auth.currentBranchId
          });
        }
      },
      viewDigitalSignatureAnswers(customerConsentFormId) {
        if (this.$refs.digitalSignatureAnswersModal) {
          this.$refs.digitalSignatureAnswersModal.open(customerConsentFormId);
        }
      },
      downloadDigitalSignatureForm(customerConsentFormId) {
        this.$toastr.warning(this.$t('FileDownloadStarted'));

        const url = `/consentForm/DownloadDigitalSignatureForm?customerConsentFormId=${customerConsentFormId}`;

        axios.get(url, { responseType: 'blob' })
          .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'DigitalSignatureForm.pdf';

            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="([^"]+)"/);
              if (fileNameMatch && fileNameMatch.length === 2) {
                fileName = fileNameMatch[1];
              }
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

            this.$toastr.success(this.$t('FileDownloadCompleted'));
          })
          .catch(() => {
            this.$toastr.error(this.$t('Error'));
          });
      },
      onDigitalSignatureSent() {
        refreshSmartDuoData();
      }
    },
    watch: {
      'consentForm.id': function (val) {
        if (val && val.length > 0) {
          this.insertCustomerConsentForm();
        }
      }
    },
    mounted() {
      this.getConsentFormList();
      this.getCustomerInfo();

      // Override global functions for SmartTable row actions
      window.openDigitalSignatureModal = this.openDigitalSignatureFromRow;
      window.showDigitalSignatureAnswers = this.viewDigitalSignatureAnswers;
      window.viewDigitalSignatureAnswers = this.viewDigitalSignatureAnswers;
      window.downloadDigitalSignatureForm = this.downloadDigitalSignatureForm;
      window.vm.$digitalSignatureAnswersModal = this.$refs.digitalSignatureAnswersModal;
    },
    beforeDestroy() {
      delete window.openDigitalSignatureModal;
      delete window.showDigitalSignatureAnswers;
      delete window.viewDigitalSignatureAnswers;
      delete window.downloadDigitalSignatureForm;
      window.vm.$digitalSignatureAnswersModal = null;
    }
  }
</script>
